import { getOwnedProducts } from 'self-service-api/api/getProducts';
import { HAS_FREE_OVERRIDE, HAS_PAID_OVERRIDE } from 'ui-addon-upgrades/_core/utils/commMethodOverrides';
export const getIsFreePortal = () => {
  if (HAS_FREE_OVERRIDE) {
    return Promise.resolve(true);
  }

  if (HAS_PAID_OVERRIDE) {
    return Promise.resolve(false);
  }

  return getOwnedProducts().then(productsOwned => {
    if (!productsOwned || !Array.isArray(productsOwned)) {
      return true;
    } else {
      return productsOwned.length === 0;
    }
  }).catch(() => {
    return true;
  });
};